<p *ngIf="error" role="alert">{{ error }}</p>
<tt-page>
    <tt-list [ttData]="items" [ttGoto]="false" (ttClick)="openItem($event)"></tt-list>
</tt-page>
